import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import type { LegacyResponse } from "./response.model";
import type { Planet, UserVoucher, Voucher, VoucherType } from "@models";
import { CryptoInfo } from "src/app/shared/model/crypto.model";
import type { IFuturesVoucher } from "src/app/futures/classes/FuturesVoucher";

@Injectable({ providedIn: "root" })
export class VoucherService {
  private _vouchersApiUrl = environment.vouchersApiUrl;
  private _voucherApiUrlV2 = environment.vouchersV2ApiUrl;

  constructor(private _httpClient: HttpClient) {}

  public getVouchers() {
    return this._httpClient.get<LegacyResponse<UserVoucher[]>>(`${this._vouchersApiUrl}/mine`);
  }

  public getUserVouchers(voucherType?: VoucherType) {
    return this._httpClient.get<{ vouchers: UserVoucher[] }>(`${this._voucherApiUrlV2}/mine`, {
      params: voucherType ? { voucherType } : {},
    });
  }

  public getPurchasableVouchers(planet?: Planet) {
    return this._httpClient.get<{ products: Voucher[] }>(
      `${this._voucherApiUrlV2}/earn/available-products`,
      {
        params: planet ? { planet } : {},
      },
    );
  }

  public getVoucherByCode(code: string) {
    return this._httpClient.get<UserVoucher>(`${this._voucherApiUrlV2}/search`, {
      params: { voucherCode: code },
    });
  }

  public getFuturesVoucherByCode(code: string) {
    return this._httpClient.get<IFuturesVoucher>(`${this._voucherApiUrlV2}/ft/search`, {
      params: { voucherCode: code },
    });
  }

  public getCryptoInfo(query?: string) {
    return this._httpClient.get<CryptoInfo>(`${this._voucherApiUrlV2}/instruments/crypto`, {
      params: { query: query || "" },
    });
  }

  public getUserAvailableTokens() {
    return this._httpClient.get<{ amount: number }>(`${this._voucherApiUrlV2}/earn/tokens`);
  }

  public purchaseVouchers(voucherIds: string[]) {
    return this._httpClient.post<{ vouchers: UserVoucher[] }>(
      `${this._voucherApiUrlV2}/earn/purchase`,
      {
        productIds: voucherIds,
      },
    );
  }
}
